import { injectable } from 'inversify';

import { action, computed, makeObservable, observable } from 'mobx';
import type { ISugerySaveStateUpdateSubscriber } from './interfaces';

const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
  event.preventDefault();
  event.returnValue = 'You have made changes to this plan which have not yet been saved.';
};

@injectable()
export class SavingStateController {
  private _canSaveCase = false;

  private _saveStateSubscriber?: ISugerySaveStateUpdateSubscriber;

  @observable
  private _isChanged = false;

  public constructor() {
    makeObservable(this);
  }

  public init(canSaveCase: boolean, surgerySaveStateSubscriber: ISugerySaveStateUpdateSubscriber): void {
    this._canSaveCase = canSaveCase;
    this._saveStateSubscriber = surgerySaveStateSubscriber;
  }

  public initSubscriptions(): void {
    if (!this._saveStateSubscriber) {
      throw new Error('_saveStateSubscriber should be defined');
    }
    this._saveStateSubscriber.initSubcriptions(() => this.setChangedState(true));
  }

  @computed
  public get isChanged(): boolean {
    return this._isChanged;
  }

  @action
  public setChangedState(state: boolean): void {
    this._isChanged = state;
    if (this._isChanged && this._canSaveCase) {
      window.onbeforeunload = handleBeforeUnload;
    } else {
      window.onbeforeunload = null;
    }
  }
}
